export const menuGetters = {
  getInternalMenu: (state) => {
    return (keyword) => {
      const result = Object.keys(state.internalMenu).reduce(function (r, e) {
        if (state.internalMenu[e].name && state.internalMenu[e].name === keyword) {
          r[e] = state.internalMenu[e]
        }
        return r
      }, {})
      if (result && Object.keys(result).length > 0) {
        // Return the 1st result of the filter
        let formatResult = result[Object.keys(result)[0]]
        Object.assign(formatResult, { key: Object.keys(result)[0] })
        return formatResult
      } else {
        return undefined
      }
    }
  },
  // Get from route menu (access check)
  getRouteMenu: (state) => {
    return (keyword) => {
      const result = Object.keys(state.routeMenu).reduce(function (r, e) {
        if (state.routeMenu[e].name && state.routeMenu[e].name === keyword) {
          r[e] = state.routeMenu[e]
        }
        return r
      }, {})
      if (result && Object.keys(result).length > 0) {
        // Return the 1st result of the filter
        let formatResult = result[Object.keys(result)[0]]
        Object.assign(formatResult, { key: Object.keys(result)[0] })
        return formatResult
      } else {
        return undefined
      }
    }
  },
  derieveBreadcrumb: (state) => {
    return (key) => {
      let result = []
      findParent(key, result, state)
      return result
    }
  },
  derieveBreadcrumbByName: (state, getters) => {
    return (keyword) => {
      // Merge getInternalMenu and DerieveBreadCrumb
      const internalKey = getters.getInternalMenu(keyword)
      if (internalKey && internalKey.key) {
        return getters.derieveBreadcrumb(internalKey.key)
      } else {
        return []
      }
    }
  }
}

const findParent = (key, result, state) => {
  if (state.internalMenu[key]) {
    result.unshift(state.internalMenu[key])
    // Check for parent relation
    if (key.lastIndexOf('.') !== -1) {
      const nextKey = key.substr(0, key.lastIndexOf('.'))
      findParent(nextKey, result, state)
    }
  }
}
